// extracted by css-extract-rspack-plugin
export default {"root":"w_nRZ"};